import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import RoleProtectedRoute from 'components/RoleProtectedRoute';
import DashboardLayout from 'layout/Dashboard';
import ErrorPageComponent from 'components/ErrorPage';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - Management pages
const Organizations = Loadable(lazy(() => import('pages/organizations')));
const Cashiers = Loadable(lazy(() => import('pages/cashiers')));
const Reductions = Loadable(lazy(() => import('pages/reductions')));
const ScanEvents = Loadable(lazy(() => import('pages/scan-events')));
const Emails = Loadable(lazy(() => import('pages/emails')));
const Admins = Loadable(lazy(() => import('pages/admins')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  errorElement: <ErrorPageComponent />,
  children: [
    {
      index: true, // This handles the root path "/"
      element: <Navigate to="/dashboard/default" replace />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        },
      ]
    },
    {
      path: 'organizations',
      element: <Organizations />
    },
    {
      path: 'cashiers',
      element: <Cashiers />
    },
    {
      path: 'reductions',
      element: <Reductions />
    },
    {
      path: 'scan-events',
      element: <ScanEvents />
    },
    {
      path: 'emails',
      element: <Emails />
    },
    {
      path: 'admins',
      element: (
        <RoleProtectedRoute allowedRoles={['owner', 'super_admin']}>
          <Admins />
        </RoleProtectedRoute>
      )
    },
  ]
};

export default MainRoutes;
